import { Link } from "react-router-dom";
import { realms } from "@/mocks/realms";

export default function RealmsShowcase() {
  const shown = realms.slice(0, 4);

  return (
    <section className="border-y border-background-200 bg-background-100/60 py-12 md:py-16">
      <div className="container-x">
        <div className="flex items-end justify-between gap-4">
          <div>
            <p className="text-xs font-medium tracking-widest text-primary-600">修炼境界</p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">从炼气到飞升的境界阶梯</h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-500">
              每一层境界对应怎样的实力与际遇？把整套修炼体系一次讲明白。
            </p>
          </div>
          <Link
            to="/section/jingjie"
            className="hidden items-center gap-1 whitespace-nowrap text-sm text-primary-600 hover:text-primary-700 sm:flex"
          >
            完整境界体系
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 lg:grid-cols-4">
          {shown.map((r) => (
            <Link
              key={r.id}
              to="/section/jingjie"
              className="group overflow-hidden rounded-xl border border-background-200/70 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-accent-200 hover:shadow-soft"
            >
              <div className="w-full overflow-hidden">
                <div className="aspect-square w-full">
                  <img
                    src={r.cover}
                    alt={`${r.name} 境界水墨配图`}
                    title={`${r.name}境 · 师兄啊师兄修炼境界`}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-base font-semibold text-foreground-950">{r.name}</h3>
                  <span className="text-xs text-accent-600">{r.stage}</span>
                </div>
                <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-500">{r.desc}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}